import { RESET_FLASH_REPORT_GRID_ROWS } from './actionTypes';

export const resetFlashReportGridRows = () => ({ type: RESET_FLASH_REPORT_GRID_ROWS });
